import { combineReducers } from "redux";
import authReducer from "./authReducer";
import chatHistoryReducer from "./chatHistorySlice";

import projectReducer from "./projectReducer";

import chatReducer from "./chatReducer";

import intakeReducer from "./intakeReducer";
import closeOutReducer from "../closeoutslice/closeoutSlice";
import closeOutRadioReducer from "../closeoutslice/closeOutRadioSlice";
import userReducer from "./users/usersReducer";
import appDataReducer from "./appData/appDataReducer";
import userAccessReducer from "./users/userAccessReducer";
import engagementDataReducer from "../engagementHistory/engagementHistorySlice";
import chatQuestionReducer from "./chatQuestionHistory/chatQuestionHistoryReducer";
import sidebarReducer from "../sideBar/sideBarSlice";
import chatFavouriteReducer from "./chatFavourites/chatFavoriteReducer";
import archievedChatsReducer from "./chatActions/archivedChatsReducer";
import chatHistoryActionReducer from "./chatHistoryActionReducer";
const rootReducer = combineReducers({
  chat: chatReducer,
  project: projectReducer,
  auth: authReducer,
  historical: intakeReducer,
  chatHistory: chatHistoryReducer,
  closeOut: closeOutReducer,
  CloseOutRadio: closeOutRadioReducer,
  users: userReducer,
  appData: appDataReducer,
  userAccess: userAccessReducer,
  engagementData: engagementDataReducer,
  chatQuestionHistory: chatQuestionReducer,
  sidebar: sidebarReducer,
  favouriteChat: chatFavouriteReducer,
  archievedChats: archievedChatsReducer,
  chatHistoryAction: chatHistoryActionReducer,
  // favouriteChats: favouritesChatReducer,
  // Add other reducers here as needed
});

export default rootReducer;
